import { Button } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import * as React from 'react';
import { GridSelectionModel } from '@mui/x-data-grid-pro';
import { Action, ActionHandler, getEnabledActions } from '../../../actions';
import { ActionMenu } from '../../action-menu';

interface Props {
  onAction: ActionHandler;
  selection: GridSelectionModel;
}

export const Actions: React.FC<Props> = (props) => {
  const [anchor, setAnchor] = React.useState<null | HTMLButtonElement>(null);

  const { onAction, selection } = props;

  const enabledActions = getEnabledActions(selection);

  const handleActionClick = (action: Action) => {
    setAnchor(null);
    onAction(action, selection);
  };

  return (
    <div>
      <Button
        id="demo-customized-button"
        aria-controls={anchor ? 'demo-customized-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={anchor ? 'true' : undefined}
        variant="outlined"
        color="info"
        disableElevation
        onClick={(e) => setAnchor(e.currentTarget)}
        startIcon={<KeyboardArrowDownIcon />}
      >
        Actions
      </Button>
      <ActionMenu
        anchor={anchor}
        onClose={() => setAnchor(null)}
        onAction={handleActionClick}
        enabledActions={enabledActions}
      />
    </div>
  );
};
Actions.displayName = 'Actions';
